module.exports = __webpack_public_path__ + "static/media/four-digits-serial-number.41f538d3.png";